import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL + 'cmd/';

class CmdService {

    getQueued(bId, offset, limit, startDate = null, endDate = null) {
        return axios.get(API_URL + 'getqueued/' + bId,
            {
                params: {
                    limit: limit,
                    offset: offset,
                    startDate: startDate,
                    endDate: endDate
                },
                headers: authHeader()
            }
        );
    }

    getSent(bId, offset, limit, startDate = null, endDate = null) {
        return axios.get(API_URL + 'getsent/' + bId,
            {
                params: {
                    limit: limit,
                    offset: offset,
                    startDate: startDate,
                    endDate: endDate
                },
                headers: authHeader()
            }
        );
    }

    getRegistered() {
        return axios.get(API_URL + 'getregistered/', { headers: authHeader() });
    }

    getResponses(bId, offset, limit, startDate = null, endDate = null) {
        return axios.get(API_URL + 'getresponses/' + bId,
            {
                params: {
                    limit: limit,
                    offset: offset,
                    startDate: startDate,
                    endDate: endDate
                },
                headers: authHeader()
            }
        );
    }

    addCmd(bId, cmd) {
        return axios.put(API_URL + 'addcmd/' + bId, {
            cmd: cmd
        },
            { headers: authHeader() });
    }

    addCmdRegistered(cmd) {
        // Rétro-compatible :
        // - ancien usage : addCmdRegistered("setparam xxx")
        // - nouveau usage : addCmdRegistered({ name, cmd, baliseType })
        const payload = (typeof cmd === 'string')
            ? { cmd: cmd }
            : cmd;
        return axios.put(
            API_URL + 'addcmdregistered/',
            payload,
            { headers: authHeader() }
        );
    }

    deleteCmdRegistered(id) {
        return axios.delete(
            API_URL + 'deletecmdregistered/' + id,
            { headers: authHeader() }
        );
    }

    getButtons(baliseId) {
        return axios.get(
            API_URL + 'getbuttons/' + baliseId,
            { headers: authHeader() }
        );
    }

    setButtons(baliseId, buttons) {
        return axios.put(
            API_URL + 'setbuttons/' + baliseId,
            { buttons },
            { headers: authHeader() }
        );
    }

    runRegistered(bId, cmdId) {
        return axios.post(
            API_URL + `runregistered/${bId}/${cmdId}`,
            {},
            { headers: authHeader() }
        );
    }

    executeAction(bId, cmdId) {
        return axios.post(
            API_URL + `executeAction/${bId}/${cmdId}`,
            {},
            { headers: authHeader() }
        );
    }

}

export default new CmdService();